module.exports = {"532624101":"麻栗镇","532624102":"大坪镇","532624103":"董干镇","532624104":"天保镇","532624201":"猛硐瑶族乡","532624202":"下金厂乡","532624203":"八布乡","532624204":"六河乡","532624205":"杨万乡","532624206":"铁厂乡","532624207":"马街乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/532624.json
// module id = 2776
// module chunks = 0